import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { AchievementModuleDataObj, WVCustom, WVMain } from '../wallboard-view.model';
import { AchievementSettingsTransferObj, ModuleType } from '../../wallboards.model';

@Component({
    selector: 'cv-wallboard-view-custom-achievement',
    templateUrl: './wallboard-view-custom-achievement.component.html',
    styleUrls: ['./wallboard-view-custom-achievement.component.scss']
})
export class WallboardViewCustomAchievementComponent implements OnInit, OnDestroy {
    @Input() index;
    @Input() height;
    @Input() width;
    @Input() firstSlide;

    private wvf: WVMain;
    private wvcf: WVCustom;
    public achievementState: AchievementSettingsTransferObj;
    public achievementData: AchievementModuleDataObj[] = [];

    public rotations;

    private isDestroyed: boolean = false;

    get hasBackdrop(): boolean {
        return this.wvcf?.Slide.HasBackdrop ?? false;
    }

    get moduleKey(): string {
        return this.wvcf?.Slide.WallboardModuleDetails[this.index].WallboardModuleKey ?? "";
    }

    constructor(
        public service: WallboardViewService,
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvcf = this.service.WVCustom;
        this.rotations = Math.floor(this.wvcf.Slide.SlideInterval / 5);

        let moduleState = this.service.loadModuleState(ModuleType.Achievement, this.wvf.WallboardCreatorID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.achievementState = response.achObj;
        });

        let achievementModuleData = this.service.getAchievementModuleData(this.wvcf.Slide.WallboardID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.achievementData = response;
        });

        Promise.all([moduleState, achievementModuleData]).then(responses => {
            // If not first slide, notify WallboardViewCustom this module is ready.
            if (!this.firstSlide)
                this.wvcf.ReadyModules.push(this.moduleKey);

            this.runSlide();
        });
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    runSlide() {
        if (this.wvf.RunSlide)
            this.innerTransition();
        else {
            setTimeout(function () {
                this.runSlide();
            }, 1000);
        }
    }

    innerTransition() {
        // Rotate the carousel the length of 5 tiles every 5 secs.
        if (this.rotations > 0) {
            setTimeout(() => {
                let car = angular.element(".achCarousel[mid=" + this.moduleKey + "]")[0];
                let tile = angular.element(".achCarousel[mid=" + this.moduleKey + "]").find(".achTile")[0];
                if (car && tile)
                    angular.element(".achCarousel[mid=" + this.moduleKey + "]").css("left", (car.style.left != "" ? parseInt(car.style.left) : 0) - (tile.clientWidth * 5) + "px");

                this.rotations--;
                this.innerTransition();
            }, 5000);
        }
    }
}
